import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class ExpenseManageService {

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient) {
  }

  addExpensePayeeDetails(addExpPayee,AUTHTOKEN) {
    const params = addExpPayee;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/addExpensePayee',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  addExpensePaymentMethodDetails(PaymentMethodData,AUTHTOKEN) {
    const params = PaymentMethodData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/addExpensePaymentMethod',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  addExpenseAccountDetailsForTable(Data,AUTHTOKEN) {
    const params = Data;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/addExpenseAccountTypeListForTable',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  addExpenseItemDetailsForTable(Data,AUTHTOKEN) {
    const params = Data;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/addExpenseItemDetailsForTable',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  getExpensePayeeListService(schoolId,academicId,AUTHTOKEN) {
    const params = {schoolId:schoolId,academicId:academicId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getExpensePayeeList',
      params, {headers: headers})
      .pipe(map(res => res));
  }


  getExpensePaymentMethodListService(schoolId,academicId,AUTHTOKEN){
    const params = {schoolId:schoolId,academicId:academicId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getExpensePaymentMethodList',
      params, {headers: headers})
      .pipe(map(res => res));
  }


  getExpenseAccountTypeListForTableService(schoolId,academicId,AUTHTOKEN){
    const params = {schoolId:schoolId,academicId:academicId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getExpenseAccountTypeListForTable',
      params, {headers: headers})
      .pipe(map(res => res));
  }


  getExpenseItemServiceListForTableService(schoolId,academicId,AUTHTOKEN){
    const params = {schoolId:schoolId,academicId:academicId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getExpenseItemServiceListForTable',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  addExpenseFormBlockOneService(Data,AUTHTOKEN){
    const params = Data;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/addExpenseFormBlockOne',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  expenseViewListForService(getSchoolId,academicId,AUTHTOKEN) {
    const params = {getSchoolId: getSchoolId, academicId: academicId };
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getExpenseListForView',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  getExpenseDetailsByExpenseIdService(expenseId,schoolId,academicId,AUTHTOKEN) {
    const params = {pkExpenseId:expenseId,getSchoolId:schoolId,academicId:academicId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getExpenseDetailsByExpenseId',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  updateExpenseDetailsByIdService(data,AUTHTOKEN){
    const params = data;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/updateExpenseDetailsById',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  getSchoolExpensesTotalAmountServices(schoolId,AUTHTOKEN){
    const params = {getSchoolId:schoolId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getSchoolExpensesTotalAmount',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  searchStaffForPayeeService(searchData,AUTHTOKEN){
    const params = {searchData:searchData};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/searchStaffForPayee',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  staffListService(schoolId,AUTHTOKEN){
    const params = {getSchoolId:schoolId};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/getStaffList',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  deleteExpenseAccLineItemService(deleteItemLine,AUTHTOKEN){
    const params = {pkAddExpenseId:deleteItemLine};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/deleteAccLineItemEdit',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  deleteExpenseItemLineService(deleteItemLine,AUTHTOKEN){
    const params = {pkExpenseItemId:deleteItemLine};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/expense/deleteItemLineInEdit',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  getFinancialTermsOverviewFee(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/manageFees/expenses/financialterm/overviewfee',
      params, {headers:headers})
      .pipe(map(res => res));
  }
}
